import { render, staticRenderFns } from "./intgsetupGrid.vue?vue&type=template&id=73c6c8d1"
import script from "./intgsetupGrid.vue?vue&type=script&lang=js"
export * from "./intgsetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports